export default {"src":"/_next/static/media/ic_minus_button.f1c94ec7.svg","height":3,"width":18,"blurWidth":0,"blurHeight":0};